export default "__VITE_ASSET__jfq7WtoI__"